<template>
	<slot></slot>
	<div v-if="ro" class="fileZone" :style="style">
		<div class="fileZoneReadOnlyText">
			<sym-icon name="upload" :class="fileEntryProps.clickClass"/>
			<div>{{env.msg("fileZone.drag.short")}}</div>
		</div>
	</div>
	<div v-else @drop.prevent="onDrop" :data-active="active" 
		@dragenter.prevent="setActive" @dragover.prevent="setActive"
		@dragleave.prevent="setInactive" :class="dropClass" class="fileZone" :style="style">
		<template v-if="uploadingFile">
			<close-cross v-show="uploadingFileDone" class="fileZoneCancelIcon" @click="removeFile"></close-cross>
			<img v-if="fileEntryProps.preview && uploadingFileDone && isPicture" :src="thumbnailUrl" class='fileZoneImg'/>
			<div v-else class="fileZoneText">
				<span v-show="uploading" class="fi uploadingIcon"></span>
				<span v-if="fileEntryProps.showTitles">{{uploadingFile.uploadingTitle}}</span>
			</div>
		</template>
		<template v-else>
			<div v-if="active" class="fileZoneText">
				<span v-if="fileEntryProps.showTitles">{{env.msg("fileZone.drop")}}</span>
			</div>
			<template v-else-if="!fileEntryProps.showTitles" >
				<div class="fileZoneText">
					<sym-icon name="upload" @click.prevent="onFileInput"/>
				</div>
			</template>
			<template v-else >
				<div class="fileZoneText">
					<span>{{env.msg("fileZone.drag.short")}}</span>
				</div>
				<div class="fileZoneButtons">
					<button v-if="fileEntryProps.showDisc" class="sbutton" @click.prevent="onFileInput">
						<sym-icon name="upload"/> <span>{{env.msg("fileZone.fromDisc")}}</span>
					</button>
					&nbsp;
					<button v-if="fileEntryProps.showClip" class="sbutton" @click.prevent="onClipboard">
						<sym-icon name="clipboard"/> <span>{{env.msg("fileZone.fromClipboard")}}</span>
					</button>
					&nbsp;
					<file-browser-modal v-if="fileEntryProps.showDoc" :button="true" @select-file="onCrmFile"/>
				</div>
			</template>
		</template>
		<input type="file" ref="fileInputId" @change="onInputChange" style="display: none;" />
		<input type="hidden" :name="fileEntryProps.property" :value="value" />
	</div>
	<div v-if="isError" class="errors">
		<span class="perr">{{errorMessage}}</span>
	</div>
</template>
<script setup lang="ts">
	import { useBaseFile } from './BaseFile';
	import {ref, reactive, computed, onMounted, onUnmounted} from 'vue';
	import FileBrowserModal from '@/vue/file/FileBrowserModal.vue';
	import CloseCross from "./CloseCross.vue";
	import {injectEnv} from "@fd/Environment";
	import type {FileEntry} from "@t/fd/editor/FileEntry";
	import useEditor, {type EditorProps, editorProps} from "@fd/editors/Editor";
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	
	const uprops = defineProps({...editorProps});
	const props = uprops as EditorProps;
	const fileEntryProps = computed<FileEntry>(() => props.part as FileEntry);
	const {visible, value, clazz, style, ro, errorClass} = useEditor(props);
	
	//set defaults - ERROR - can't change props ???
	/*if (!fileEntryProps.value.endpoint) {
		fileEntryProps.value.endpoint = "api/files/uploadCrmFile";
	}
	if (!fileEntryProps.value.type) {
		fileEntryProps.value.type = "file-entry";
	}*/
	
	console.log("setting url:"+fileEntryProps.value.endpoint+" / type:"+fileEntryProps.value.type);
	
	
	const env = injectEnv();
	
	const emit = defineEmits(['uploaded']);
	
	const { CLASSEVENTS, dropClass, errorMessage, isError, 
			uploadingFile, uploading, uploadingFileDone,
			active, setActive, setInactive, 
			onDrop, onInputChange, onClipboard, onCrmFile,
			loadFile } = useBaseFile(fileEntryProps.value, uploadedFile,uploadedAllFiles, endpoint, emit);
	
	//const { thumbnailUrl, limitFileName } = useCrmFormFile();
	
	const fileInputId = ref(null);
	
	function uploadingFileName(): string {
		return uploadingFile.value !== null?uploadingFile.value.getName():"-";
	}
	defineExpose({uploadingFileName});


	const thumbnailUrl = computed(() => {
		let url:string = "thumbnail?crmFormFile="+value.value+"&random="+Math.random();
		if (fileEntryProps.thumbnailHeight && fileEntryProps.thumbnailWidth) {
			url +="&height="+fileEntryProps.thumbnailHeight+"&width="+fileEntryProps.thumbnailWidth;
		}
		return url;
	});

	const isPicture = computed(() => {
		if (uploadingFile.value !== null) {
			//console.log("isPicture:"+uploadingFile.getType());
			return  uploadingFile.value.getType().includes("image") || 
					(uploadingFile.value.attFileContentType && uploadingFile.value.attFileContentType.includes("image"));
		}
		return false;
	});
	
	function preventDefaults(e): void {
		e.preventDefault();
	}
	
	function uploadedFile(data): void {
		console.log("uploaded file:"+JSON.stringify(data));
		value.value = data.id;
		uploadingFile.value.setAttFileContentType(data.contentType);
		
		emit('uploaded',uploadingFile.value);
	}
	
	function uploadedAllFiles(): void {
		//nothing
	}
	
	function endpoint(): void {
		//nothing
	}
	
	function removeFile(): void {
		console.log("removing:"+value.value);
		value.value="";
		uploadingFile.value=null;
	}
	
	function onFileInput(): void {
		fileInputId.value.click();
	}
	
	onMounted(() => {
		CLASSEVENTS.forEach((eventName) => {
			document.body.addEventListener(eventName, preventDefaults);
		});
		
		if (value.value && value.value.length>0) {
			loadFile(value.value).then((file)=>{
				uploadingFile.value=file;
				uploadingFileDone.value=true;
			});
		}
	});
	
	onUnmounted(() => {
		CLASSEVENTS.forEach((eventName) => {
			document.body.removeEventListener(eventName, preventDefaults);
		});
	});
</script>